// extracted by mini-css-extract-plugin
export default {"readonlyValue":"styles_readonlyValue__cR6i4"};